import youtube from './youtube'

const videoPlayer = {
  el: '',
  elBtn: '',
  init() {
    this.el = $q('.videoplayer')
    this.elBtn = $q('.videoplayer button')

    if (!this.el.first) return

    youtube.elBtns = this.elBtn
    youtube.onClick = () => {
      this.el.first.classList.add('playing')
    }
    youtube.init()
  }
}

export default videoPlayer
